<script>
import UserIcon from '@/assets/login_images/user_icon.vue';
import TenantIcon from '@/assets/login_images/tenant_icon.vue';
import PasswdIcon from '@/assets/login_images/passwd_icon.vue';
import PasswdShow from '@/assets/login_images/passwd_show.vue';
import PasswdHide from '@/assets/login_images/passwd_hide.vue';
import { mapGetters, mapActions } from 'vuex';
import { TokenKey } from '@/utils/accessToken';
import { Cookie } from '@/utils/storage';
export default {
  name: 'Login',
  components: { TenantIcon, UserIcon, PasswdIcon, PasswdShow, PasswdHide },
  props: {
    welcomeTitle: {
      type: String,
      default: '',
    },
    bgImgPath: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tenantMode: false,
      form: {
        account: '',
        password: '',
        vcode: '',
      },
      passwordType: 'password',
      userFocus: false,
      passFocus: false,
      loginText: this.$t('登录'),
    };
  },
  computed: {
    ...mapGetters({
      title: 'settings/title',
    }),
  },
  beforeRouteEnter(to, from, next) {
    let nextRoute = { path: '/' };
    // query 有 token
    if (to.query.tp_token) {
      let hasToken = Cookie.get(TokenKey);
      if (!hasToken) {
        // window.localStorage.setItem(TokenKey, this.$route.query.tp_token)
        Cookie.set(TokenKey, to.query.tp_token, 1.9);
      }
      let queryData = to.query;
      delete queryData.tp_token;
      next((vm) => {
        vm.$router.replace({ path: '/', query: queryData });
      });
    } else {
      next();
    }
  },
  methods: {
    ...mapActions({
      login: 'user/login',
    }),
    showPassword() {
      this.$refs.pass.focus();
      this.passwordType = 'text';
    },
    hidePassword() {
      this.$refs.pass.focus();
      this.passwordType = 'password';
    },
    async handleLogin() {
      this.loginText = this.$t('登录中');
      let loginMsg = await this.login(this.form);
      //只要vuex中的login返回true，则认为登录成功
      if (loginMsg) {
        this.$router.push('/');
      } else {
        this.loginText = this.$t('登录');
      }
    },
  },
};
</script>
<template>
  <div id="login">
    <div id="loginbg"></div>
    <div id="loginform" @keyup.enter="handleLogin">
      <!-- <img id="logo" src="@/assets/logo.png" /> -->
      <slot name="prefix"></slot>
      <div class="welcome">
        <p class="text chi">{{ welcomeTitle ? $t(welcomeTitle) : $t(title) }}</p>
        <p class="text eng">WELCOME</p>
      </div>
      <div v-if="tenantMode" class="login_input">
        <div class="login_icon">
          <tenant-icon></tenant-icon>
        </div>
        <input v-model="form.tenantId" :placeholder="$t('请输入') + $t('租户id')" />
      </div>
      <div class="login_input">
        <div class="login_icon">
          <user-icon></user-icon>
        </div>
        <input v-model="form.account" :placeholder="$t('请输入') + $t('账号')" />
      </div>
      <div class="login_input passwd">
        <div class="login_icon">
          <passwd-icon></passwd-icon>
        </div>
        <input ref="pass" v-model="form.password" :type="passwordType" :placeholder="$t('请输入') + $t('密码')" />
        <passwd-show
          v-if="passwordType == 'password'"
          @click.native="showPassword"
          @mousedown.native.prevent
          @mouseup.native.prevent
        ></passwd-show>
        <passwd-hide v-else @click.native="hidePassword" @mousedown.native.prevent @mouseup.native.prevent></passwd-hide>
      </div>

      <button class="loginbtn" @click="handleLogin">{{ loginText }}</button>
      <slot name="affix"></slot>
    </div>
  </div>
</template>
<style lang="scss">
html,
body,
#login {
  width: 100%;
  height: 100%;
  margin: 0;
  font-family: v-sans, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
    'Segoe UI Symbol';
}

#login {
  display: flex;
}
#logo {
  position: fixed;
  right: 4.7625vw;
  top: 4.375vh;
}
#loginbg {
  height: 100%;
  width: 61.1vw;
  background-image: url('~@/assets/login_images/loginbg.webp');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
#loginform {
  height: 100%;
  flex: 1;
  min-width: 500px;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .welcome {
    width: 29.375vw;
    position: relative;
    height: 90px;
    margin-bottom: 50px;
    min-width: 350px;
    .text {
      margin: 0;
      position: absolute;
      line-height: 1;
      &.eng {
        top: 0;
        font-size: 90px;
        font-weight: bold;
        color: rgb(242, 243, 245);
      }
      &.chi {
        top: 50%;
        z-index: 9;
        transform: translateY(-50%);
        color: rgb(51, 51, 51);
        font-size: 42px;
        font-weight: bold;
      }
    }
  }
  .login_input {
    height: 5.84vh;
    min-height: 44px;
    width: 29.375vw;
    min-width: 350px;
    border: 1px solid #d2d7da;
    border-radius: 3px;
    margin: 10px;
    box-sizing: border-box;
    display: flex;
    &:focus-within {
      border: 1px solid #3083fd;
      box-shadow: 0 0 0 2px rgba(48, 131, 253, 0.2);
      .login_svg {
        fill: #3083fd;
      }
    }
    .login_icon {
      width: 5.84vh;
      min-width: 44px;
      height: 100%;
      border-right: 1px solid #d2d7da;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &.passwd {
      position: relative;
      .passwd_affix {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 15px;
        cursor: pointer;
        display: flex;
        align-items: center;
      }
    }
  }
  input {
    flex: 1;
    border: none;
    border-radius: 3px;
    padding: 10px;
    height: 100%;
    box-sizing: border-box;
    font-size: 15px;
    &:focus {
      //   border: 1px solid #3083fd;
      outline: none;
      //   box-shadow: 0 0 0 2px rgba(48, 131, 253, 0.2);
    }
  }
  .loginbtn {
    height: 6.25vh;
    min-height: 44px;
    width: 29.375vw;
    min-width: 350px;
    padding: 0;
    box-sizing: border-box;
    margin-top: 5.21vh;
    cursor: pointer;
    background-color: #3083fd;
    color: #fff;
    border: none;
    border-radius: 3px;
    font-size: 22px;
    letter-spacing: 2px;
    &:hover {
      background-color: #4690fd;
    }
    &:active {
      background-color: #2b78ea;
    }
  }
}
@media only screen and (max-width: 1285px) {
  #logo {
    right: 69px;
  }
}
</style>
